import { GetObjectPropertyHelperBase } from './GetObjectPropertyHelperBase';
export class GetSymbolObjectPropertyHelper extends GetObjectPropertyHelperBase {
    getObject(sb) {
        return sb.helpers.getSymbolObject;
    }
}

//# sourceMappingURL=GetSymbolObjectPropertyHelper.js.map
